declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  try {
    if (initialized) return
    initialized = true

    const f = window
    const b = document

    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement('script') as HTMLScriptElement
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(t)

    window.fbq('init', '1206725874775777')
  } catch (e) {
    // Silently fail — never break the page
  }
}

export function trackPageView() {
  try {
    if (window.fbq) {
      window.fbq('track', 'PageView')
    }
  } catch (e) {
    // Silently fail
  }
}

export function trackAddToCart() {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'IA para Dueños de Negocios eBook',
        content_type: 'product',
        value: 6.36,
        currency: 'USD',
      })
    }
  } catch (e) {
    // Never block navigation if pixel fails
  }
}
